<template lang="pug">
  .page-title-container
    .page-title-left(:class="{ 'hide': hideTitle }")
      slot(name="left")
        img.title(:src="titleIcon")
        .desc(v-if="titleDesc") {{ titleDesc }}
    .page-title-right
      DotBtn(v-if="pageKey === pageKeyEnum.bounty" :isNew="true")
      .coupon-btn(v-else @click="goToCouponOrderPage" v-node-expose="orderBtnExposeOptions") 购买记录
</template>

<script>
import { uiMgr } from '@/pages/mall/common/uiMgr';
import SPM from '../common/spm';
import DotBtn from '../new-version-cpns/dot-btn';
import { WELFARE_CENTER_PAGE_KEY } from '../consts';

export default {
  name: 'PageTitle',
  components: {
    DotBtn,
  },
  props: {
    titleIcon: {
      type: String,
      default: '',
    },
    titleDesc: {
      type: String,
      default: '',
    },
    hideTitle: {
      type: Boolean,
      default: false,
    },
    pageKey: {
      type: String,
      default: '',
    },
    // 页面样式版本
    styleVersion: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      // 页面key枚举
      pageKeyEnum: WELFARE_CENTER_PAGE_KEY,
    };
  },
  computed: {
    // 购买记录按钮曝光埋点配置
    orderBtnExposeOptions() {
      return {
        exposeData: {
          pageId: 'platform_couponmall',
          categoryId: 'platform',
          moduleId: 'platform_couponOrderlist',
          contentId: 'platform_couponOrderlist',
          exposureTimes: 1,
          businessInfo: {
            experimentalGroup: this.styleVersion,
            adsource: this.$route.query.adsource,
          },
        },
      };
    },
  },
  methods: {
    // 跳转到卡券购买记录页面
    goToCouponOrderPage() {
      uiMgr.pushPage({
        name: 'OrderList',
      });
      SPM.clickButton({
        pageId: 'platform_couponmall',
        buttonName: 'platform_couponOrderlist',
      });
    },
  },
};
</script>

<style lang="less" scoped>
.page-title-container {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;

  .page-title-left {
    display: flex;
    align-items: flex-end;
    transition: all 0.3s ease;

    &.hide {
      opacity: 0;
    }

    .title {
      margin-right: 0.08rem;
      height: 0.2rem;
    }

    .desc {
      font-size: 0.14rem;
      color: #383838;
    }
  }

  .page-title-right {
    position: relative;
    z-index: 1;

    .coupon-btn {
      margin-top: 0.02rem;
      display: flex;
      align-items: center;
      justify-content: center;
      box-sizing: border-box;
      font-size: 0.12rem;
      line-height: 0.16;
      color: #454545;
    }
  }
}
</style>
